module.exports = __webpack_public_path__ + "fonts/NotoSans-Bold.8bedd188.ttf";